export const strategyPageData = {
  hero: {
    title: 'Strategy Consulting Services',
    description:
      'Transform your organization with data-driven strategies that align technology, people, and processes to achieve sustainable competitive advantage in the digital age.',
  },
  overview: {
    title: 'Strategic Data Transformation',
    paragraphs: [
      "In today's rapidly evolving business landscape, organizations need more than just technology—they need a comprehensive strategy that transforms how they collect, analyze, and act on data. Our strategy consulting services help you build a roadmap for sustainable digital transformation.",
      'We work with executive teams to develop data strategies that drive business value, optimize operations, and create new revenue streams. Our approach combines industry best practices with deep understanding of your unique business context.',
      'From initial assessment to full-scale transformation, we guide organizations through every phase of their data journey, ensuring alignment between technology investments and business objectives.',
    ],
    stats: [
      { number: '70%', label: 'Faster Strategic Decision Making' },
      { number: '50%', label: 'Reduction in Implementation Time' },
      { number: '85%', label: 'Success Rate in Digital Initiatives' },
      { number: '3x', label: 'ROI on Data Investments' },
    ],
  },
  services: {
    title: 'Our Strategy Services',
    items: [
      {
        icon: '🎯',
        title: 'Data Strategy Development',
        description:
          'Create comprehensive data strategies that align with business objectives and drive measurable outcomes.',
        features: [
          'Data maturity assessment',
          'Strategic roadmap creation',
          'Governance framework design',
          'ROI modeling and planning',
          'Executive stakeholder alignment',
        ],
      },
      {
        icon: '🚀',
        title: 'Digital Transformation',
        description: 'Guide your organization through comprehensive digital transformation initiatives that deliver lasting results.',
        features: [
          'Technology stack optimization',
          'Cloud migration strategy',
          'Legacy system modernization',
          'Digital capability building',
          'Innovation framework development',
        ],
      },
      {
        icon: '⚙️',
        title: 'Process Optimization',
        description: 'Streamline operations and eliminate inefficiencies through data-driven process improvement initiatives.',
        features: [
          'Business process analysis',
          'Workflow automation design',
          'Performance metrics definition',
          'Quality improvement programs',
          'Operational excellence frameworks',
        ],
      },
      {
        icon: '🔄',
        title: 'Change Management',
        description: 'Ensure successful adoption of new technologies and processes through comprehensive change management programs.',
        features: [
          'Stakeholder engagement strategies',
          'Training and development programs',
          'Communication planning',
          'Resistance management',
          'Cultural transformation initiatives',
        ],
      },
    ],
  },
  process: {
    title: 'Our Strategic Consulting Process',
    steps: [
      { number: 1, title: 'Current State Assessment', description: 'Comprehensive analysis of your existing data capabilities, technology stack, and organizational readiness for transformation.' },
      { number: 2, title: 'Vision & Goal Setting', description: 'Collaborate with leadership to define clear objectives, success metrics, and desired future state outcomes.' },
      { number: 3, title: 'Strategic Roadmap', description: 'Develop detailed implementation roadmap with prioritized initiatives, timelines, and resource requirements.' },
      { number: 4, title: 'Pilot Implementation', description: 'Execute proof-of-concept projects to validate approach and demonstrate value before full-scale rollout.' },
      { number: 5, title: 'Full-Scale Execution', description: 'Guide implementation of strategic initiatives with continuous monitoring and adjustment as needed.' },
      { number: 6, title: 'Optimization & Scale', description: 'Continuously optimize performance and scale successful initiatives across the organization.' },
    ],
  },
  technologies: {
    title: 'Strategic Frameworks & Methodologies',
    items: [
      { icon: '📊', name: 'Data Maturity Model' },
      { icon: '🎯', name: 'OKR Framework' },
      { icon: '⚡', name: 'Agile Methodology' },
      { icon: '🔄', name: 'ADKAR Model' },
      { icon: '📈', name: 'Balanced Scorecard' },
      { icon: '🏗️', name: 'Enterprise Architecture' },
      { icon: '💡', name: 'Design Thinking' },
      { icon: '📋', name: 'TOGAF Framework' },
    ],
  },
  gallery: {
    title: 'Strategic Transformation Case Studies',
    description: 'Real examples of how our strategic consulting has transformed organizations across industries',
    items: [
      { icon: '🏦', title: 'Financial Services Transformation', description: 'Led digital transformation for a mid-size bank, resulting in 60% faster loan processing and 40% improvement in customer satisfaction scores.' },
      { icon: '🏭', title: 'Manufacturing Optimization', description: 'Implemented data-driven strategy for global manufacturer, achieving 25% reduction in operational costs and 30% improvement in supply chain efficiency.' },
      { icon: '🛒', title: 'Retail Digital Strategy', description: 'Developed omnichannel strategy for retail chain, increasing online sales by 150% and improving inventory turnover by 45%.' },
    ],
  },
  cta: {
    title: 'Ready to Transform Your Organization?',
    description: "Let's discuss how our strategic consulting can help you achieve your digital transformation goals and drive sustainable growth.",
    buttonText: 'Start Your Transformation',
  },
};
